export default __webpack_public_path__ + "static/media/fleurs.b136de36.jpg";